/**
 * The engine was not reached: the connection dropped, or something between the browser and the
 * engine answered in its stead (a load balancer's 502/503/504 page, which is not JSON). A reading
 * that costs minutes is asked after again rather than lost to it; the 2026-09-30 prod setup failed
 * on one such page when the API scaled down mid-run, and showed the customer the parser's error.
 */
export class EngineUnreachableError extends Error {
  constructor(readonly status: number) {
    super('Paige lost its connection to Cortexa for a moment. Try again in a minute.');
    this.name = 'EngineUnreachableError';
  }
}

/** A failure worth asking again: the network, or an answer that did not come from the engine. */
export function isTransient(reason: unknown): boolean {
  return reason instanceof TypeError || reason instanceof EngineUnreachableError;
}
